import { Color } from 'three'
export const teal = new Color('hsl(190,80%,40%)')
export const green = new Color(`hsl(156, 100%, 51%)`)
export const darkGreen = new Color(`#53C6AA`)
export const darkBlue = new Color('hsl(190,60%,40%)')
